import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { CTAButtonWithText } from '../CTAButtonWithText';
import { StyledCallToAction } from '../../../sharedComponents';
import { DARK, LIGHT } from '../../constants';
import { ThemeContext } from 'styled-components';

export const CTAButtonsList = ({ list, style, moduleType }) => {
  const themeConfig = useContext(ThemeContext);

  /* istanbul ignore next */
  const ctaMode = (buttonStyle) => {
    if (themeConfig.name === 'FanExpo') {
      if (buttonStyle === 'SECONDARY') {
        return 'black';
      }

      return 'none';
    }

    if (style === LIGHT) return 'black';
    return 'none';
  };

  return list
    .filter((button) => button.link.shown)
    .map((button, index) => {
      const { buttonStyle, textPosition, textNextToCTAButton, link } = button;

      const visualButtonStyles =
        themeConfig.siteBuilderModules.ctaButtonGroupModule.visualStyles[
          buttonStyle
        ];

      return (
        <CTAButtonWithText
          key={index}
          textPosition={textPosition}
          text={textNextToCTAButton}
          visualButtonStyles={visualButtonStyles}
        >
          <StyledCallToAction
            mode={ctaMode(buttonStyle)}
            ctaConfig={link}
            size="medium"
            look="accent"
            visualStyles={visualButtonStyles}
            ga4={{
              module_type: moduleType,
            }}
          />
        </CTAButtonWithText>
      );
    });
};

CTAButtonsList.propTypes = {
  list: PropTypes.array,
  style: PropTypes.oneOf([LIGHT, DARK]).isRequired,
};
